// Feature flags. Passer EXPERTISE_PAGES_ENABLED à true quand les pages
// Expertises seront finalisées, puis redéployer.
export const EXPERTISE_PAGES_ENABLED = false;
